import { useUser } from '../context/UserContext';

/**
 * Hook to check feature permissions.
 * Permissions come from /api/v1/auth/me and are derived from Ability on the backend.
 * @returns {{ can: (permission: string) => boolean, permissions: string[] }}
 */
export function usePermissions() {
    const { permissions = [] } = useUser();
    return {
        can: (permission) => permissions.includes(permission),
        permissions
    };
}
